import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {User} from "../../../shared/interface/user";

export interface DeviceAddDialogData {
  user?: User;
}

@Component({
  selector: 'app-device-add-dialog',
  templateUrl: './device-add-dialog.component.html',
  styleUrls: ['./device-add-dialog.component.scss']
})
export class DeviceAddDialogComponent implements OnInit {
  userObject?: User = null;

  constructor(
    public dialogRef: MatDialogRef<DeviceAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeviceAddDialogData,
  ) {
    this.userObject = data?.user;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
